<template>
  <div>
    <v-autocomplete
      outlined
      v-if="!readonly && !soloTexto"
      dense
      v-model="select"
      :items="Lista"
      item-text="descripcion_afiliacion"
      item-value="id_tipo_afiliacion"
      label="Tipo de Afiliacion"
      persistent-hint
      return-object
      :value="value"
      @change="$emit('input', select.id_tipo_afiliacion)"
      hide-details
    ></v-autocomplete>
    <span v-if="readonly && !soloTexto">
      <v-text-field
        hide-details
        outlined
        dense
        label="Tipo de Afiliacion"
        readonly
        filled
        :value="select.descripcion_afiliacion"
      ></v-text-field>
    </span>
    <span v-if="soloTexto">
      {{ select.descripcion_afiliacion }}
    </span>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    value: Number,
    readonly: {
      type: Boolean,
      default: false,
    },
    soloTexto: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {
      select: {},
    };
  },
  computed: {
    ...mapState("tipoafiliacion", ["Lista"]),
  },
  methods: {
    seleccionar(id) {
      //this.reset();
      if (id) {
        let pr = this.Lista.find((x) => x.id_tipo_afiliacion == id);
        if (pr) {
          this.select = pr;
        }
      }
    },
  },
  async mounted() {
    let id = this.value;
    this.seleccionar(id);
  },
  watch: {
    value: function(newVal, oldVal) {
      this.seleccionar(newVal);
    },
  },
};
</script>

<style></style>
